<script>
export default {
  name: "LandingView",
}
</script>

<template>
  <div class="d-flex flex-column justify-content-start align-items-center col-12 landing-page">

    <img src="../../assets/landingPage/landing-main-img.png" class="col-10" style="" />
    <div class="col-6 text-center fw-bold mt-4">Dance your way to rewards with Mzansi Rhythm!</div>
    <div class="col-10 fw-medium text-center mt-2" style="color: #000F56">Play for FREE and grab daily airtime rewards. Want more? Upgrade to VIP for your shot at winning bigger & better daily & monthly prizes. </div>
    <div class="lets-play-btn col-8 text-center fw-bold fs-3 p-3 mt-4"  @click="this.$router.push('/login')">Let's Play</div>
    <div class="col-4 text-center fw-bold mt-4 mb-3">Here’s How it Works</div>

    <img src="../../assets/landingPage/landing-htp-img-1.png" class="col-8 mt-5" />
    <div class="fw-bold text-center col-12 fs-3">Groove to Victory</div>
    <div class="col-8 fw-medium text-center mt-2" style="color: #000F56">Answer 7, 20 second questions for a chance to WIN airtime and unlock prizes.</div>
    <div class="col-8 fw-medium text-center mt-2" style="color: #000F56"> Each question is worth 10 coins!</div>

    <img src="../../assets/landingPage/landing-htp-img-2.png" class="col-5 mt-5" />
    <div class="fw-bold text-center col-12 fs-3">Guess Music Trivia</div>
    <div class="col-8 fw-medium text-center mt-2" style="color: #000F56">Test your music knowledge, earn points, and become the ultimate champion of rhythm.</div>

    <img src="../../assets/landingPage/landing-htp-img-3.png" class="col-5 mt-5" />
    <div class="fw-bold text-center col-12 fs-3">Guess the Song</div>
    <div class="col-8 fw-medium text-center mt-2" style="color: #000F56"> Catch that tune! Identify the song by listening to its tune.</div>
    <div class="col-8 fw-medium text-center mt-2" style="color: #000F56">  Your  ears are your greatest weapon here!</div>

    <img src="../../assets/landingPage/landing-htp-img-4.png" class="col-5 mt-5" />
    <div class="fw-bold text-center col-12 fs-3">Bonus Round</div>
    <div class="col-8 fw-medium text-center mt-2" style="color: #000F56"> Think fast and answer 1 question in just 10 seconds for a chance to double your coins. </div>
    <div class="col-8 fw-medium text-center mt-2" style="color: #000F56">  But be careful, a wrong answer will halve your coins.</div>

    <img src="../../assets/landingPage/landing-page-skip-button.png" class="col-1 mt-4" />
    <div class="d-flex flex-column justify-content-center align-items-center col-12">
      <img src="../../assets/landingPage/landing-page-benefits-vip.png" class="col-11 mt-5">
    </div>

    <div class="d-flex flex-column justify-content-center align-items-center col-12">
      <img src="../../assets/landingPage/landing-page-benefits-free.png" class="col-11 mt-5">
    </div>

    <div class="lets-play-btn col-8 text-center fw-bold fs-3 p-3 mt-4" @click="this.$router.push('/login')">Let's Play</div>

    <div class="text-center col-7 fw-medium mt-5 mb-5" style="color: #000F56">
      Join Mzansi Rhythm VIP for R5/day. T&C’s Apply. First Day Free.
    </div>


  </div>
</template>

<style scoped>
.card-style {
  border-radius: 6.5px;
  border: 0.5px dashed #B500FF;
  background: rgba(0, 127, 183, 0.06);
  backdrop-filter: blur(4px);
}

.landing-page {
  background: #F6F3FF;
}

.lets-play-btn {
  border-radius: 29px;
  background: #FFCB05;
  }
</style>